// extracted by mini-css-extract-plugin
module.exports = {"notesTextarea":"styles_notesTextarea__30q0s"};